import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { KeysEstaticas } from '@shared/constantes/KeysStaticas';
import { SessionService } from '@core/services/session.service';

export const HomeGuard: CanActivateFn = (route, state): boolean | UrlTree => {
    const sessionService = inject(SessionService);
    const router = inject(Router);

    const isCoordinadorIncidencias = sessionService.getCoordinadorIncidencias() === true; // puede gestionar incidencias y ver indicadores
    const isGestorIncidencias = sessionService.getGestorIncidencias() === true;
    const isTransportista = sessionService.getPerfil() === KeysEstaticas.PERFIL_TRANSPORTE;

    // si es coordinador, redirigimos a otra ruta segura
    if (isCoordinadorIncidencias || isGestorIncidencias) {
        return router.createUrlTree(['/Reclamacion/BuscadorIncidencias']); // <- ajusta a tu landing
    }

    if (isTransportista) {
        return router.createUrlTree(['/CitaPrevia/BuscadorCitasPrevias']); // <- ajusta a tu landing
    }

    return true;
};
